module.exports = __webpack_public_path__ + "img/9.ce6d88f7.png";